module.exports = __webpack_public_path__ + "static/media/4.b8654cc2.webp";